import React from "react";
import { bindActionCreators, Dispatch } from "redux";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { DashboardLayout } from "component/layout/dashboard";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";
import { connect } from "react-redux";
import { RootState } from "redux/store";
import { getAgentById, getUser } from "redux/selector";
import { Agent } from "model/agent";
import { styles } from "./styles";
import { Profile } from "component/shared/profile";
import { SingleAgentProfile } from "./single-agent-profile";
import { ProfileRefresh } from "component/shared/profile-refresh";
import * as env from "shared/env";

interface Props extends PageProps, 
	Router.RouteComponentProps<RouteParams>,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles> {
}

interface RouteParams {
	id: string;
}

const getId = (props: Router.RouteComponentProps<RouteParams>) => {
	return parseInt(props.match.params.id);
}

const mapStateToProps = (state: RootState, ownProps: Router.RouteComponentProps<RouteParams>) => {
	const user = getUser(state);
	const id = getId(ownProps);
	let agent: Agent | undefined;
	if (id) {
		agent = getAgentById(state, id);
	} else {
		agent = getAgentById(state, user?.agentId);
	}
	return {
		agent,
		user,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

class Component extends React.Component<Props> {

	public render() {
		const { agent, user } = this.props;
		const title = "My Profile";
		if (!agent) {
			return null;
		}
		// The refreshed page owns its own width and is reached from the profile menu, so it drops the
		// sidebar and the legacy page header — it leads with the member's name in the left panel
		// (MAX-4139). Content is centred at 1100px per the designs.
		if (env.refreshProfile) {
			return (
				<DashboardLayout
					title={title}
					hideSidebar
					fullScreen={false}
					contentMaxWidth={1100}
				>
					<ProfileRefresh agent={agent} selfView />
				</DashboardLayout>
			);
		}
		return (
			<DashboardLayout
				title={title}
				header={
					<Mui.Typography variant="h1">
						<FeatherIcon>
							<Icons.Settings />
						</FeatherIcon>
						{agent.name ? agent.name : title}
					</Mui.Typography>
				}
			>
				{(user.permissions.broker) ? (
					<Profile agent={agent}/>
				) : (
					<SingleAgentProfile agent={agent} />
				)}
				
			</DashboardLayout>
		);
	}

}

export const SettingsProfilePage = withStyles(
	Router.withRouter(connect(mapStateToProps, mapDispatchToProps)(Component)),
	styles
);